
import React from 'react';
import { Route, Routes } from 'react-router';
import { useSelector } from 'react-redux';
import CustomComponent from '../components/common/CustomComponent';
import Pages from '../constants/pages';
import { PathNames } from '../constants/AppConstants';
import Claims from '../components/pages/claims/Claims';
import ClaimDetails from '../components/pages/claims/ClaimDetails';
import LiveChatSupport from '../components/common/CustomComponents/LiveChatSupport';
import Careteam from '../components/pages/dchp/Careteam';
import PriorAuthorizations from '../components/common/CustomComponents/PriorAuthorizations';

const CustomRoutes = () => {
 const tenantLayouts = useSelector(state => state.tenant.tenantLayout);
  return (
    <Routes>
      {Pages[localStorage.getItem('tenantHandle')]&&Pages[localStorage.getItem('tenantHandle')].map(page => {
        const Component = page?.component ;
        const { path, title, config } = page;
        const pathname = PathNames[path];
        return (
          <Route key={path} exact path={pathname} element={<CustomComponent componentName={Component} title={title} config={tenantLayouts && tenantLayouts[config]}/>} />
        );
      })}
      <Route path='claims' exact element={<Claims/>} />
      <Route path='claims/:id' exact element={<ClaimDetails />} />
      <Route path='memberSupport/liveChatSupport' element={<LiveChatSupport />} />
      <Route path='careteam' element={<Careteam />} />
      <Route Path='benefits-priorAuthorizations' element={<PriorAuthorizations />} />
     </Routes>
  );
};

export default CustomRoutes;